import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteUsers as apiDeleteUsers } from "../../api/apiUsers";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteUsers() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const {
        mutate: deleteUsers,
        isPending: isDelete,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiDeleteUsers(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["users"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { deleteUsers, isDelete, error, results };
}
